<app-theme-card #cardDiv themeScope="providers" [fullWidth]="false" cardClass="flex flex-row gap-1em" [cardStyle]="{
        width: 'auto',
        'max-height': '85vh',
        'border-radius': '1rem',
        'box-shadow': 'var(--shadow-elevation-7)'
    }">

    <mat-tab-group class="flex-2" mat-stretch-tabs="false" mat-align-tabs="start"
        (selectedTabChange)="onTabChanged($event);" [disableRipple]="false" animationDuration="0ms"
        [selectedIndex]="tabSelectedIndex">
        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon [style.height.px]="24" [style.width.px]="24" svgIcon="faders-horizontal-black"></mat-icon>
            </ng-template>
            <!-- FILTERS -->
            <form class="flex-100" [formGroup]="providersForm" style="width:420px;">
                <div class="flex-column p-2">
                    <div class="flex-row line-separator "  style="font-size: small;">
                        <span class="flex-90 mxs-1 subtitle-4" style="line-height: inherit;">{{ 'modules.providers.specialties-providers-pois.informacion-general' | exp:'':'Información general' }}</span>
                        <mat-icon class="flex-1-1-auto" [color]="'primary'" style="line-height: 0.8"
                            (click)="setDataVisible()">
                            {{ dataVisible ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
                        </mat-icon>

                    </div>
                    <mat-progress-bar *ngIf="( this.entitiesFacade.isLoadingGettingProviders$() | async)"
                        [mode]="'indeterminate'" progressBarId="agreementsLoading"></mat-progress-bar>
                    <div class="p-2" [@detailExpand]="dataVisible ? 'expanded' : 'collapsed'">
                        <ng-container *ngIf="flow == 'app-provisions-detail'; else otherFlow">
                            <!-- Case Flow -->
                            <div>
                                <app-patient-data [patient]="this.patient()" [pratice]="this.practice" [specialty]="
                                        this.specialtyName"></app-patient-data>
                            </div>
                            <div class="mt-4">
                                <app-finder-location-map [inputPOI]="poi" [(center)]="center"
                                    [disabled]="true"></app-finder-location-map>
                            </div>
                        </ng-container>
                        <ng-template #otherFlow>
                            <!-- SideMenu Flow -->
                            <div>
                                <app-finder-location-map [inputPOI]="poi"
                                    [(center)]="addressSelected"></app-finder-location-map>
                            </div>
                            <div class="flex-column flex-gap-small">
                                <span class="subtitle-3 text-primary-darker">
                                    {{ 'modules.providers.specialties-providers-pois.especialidad' | exp:'':'Especialidad' }}
                                </span>

                                <app-select-searching-dynamic-input [name]="this.SPECIALTIES_ID"
                                    [nameSearching]="this.SPECIALTIES_SEARCHING" [form]="providersForm"
                                    [placeholder]="('modules.providers.specialties-providers-pois.busqueda-por-especialidad' | exp:'':'Búsqueda por especialidad')" [placeholderNoValue]="('modules.providers.specialties-providers-pois.placeholders.sin-resultados' | exp:'':'Sin resultados')"
                                    [placeholderSearching]="('modules.providers.specialties-providers-pois.placeholders.buscando-especialidad' | exp:'':'Buscando especialidad...')"
                                    [httpGet]="this.getSpecialtiesByName"
                                    (selectedWithEntity)="this.onSelectSpecialty($event)"
                                    [calculateName]="this.calculateNameSpecialty"
                                    [calculateId]="this.calculateIdSpecialty" [defaultOptions]="" [defaultValue]=""
                                    [clearable]="true">
                                </app-select-searching-dynamic-input>
                            </div>
                        </ng-template>
                    </div>

                    <app-filter-by-agreements [enableFilters]="enableFilters" [screenCalling]="this.screenCalling()"
                        (providerLocationFilter)="providersLocationsFilteredManager($event.filter, $event.value)"
                        (statusFilterEmitter)="onChangeProviderStatusFilter( $event.value, $event.name)"
                        (showPatients)="setPatientsFiltersVisible($event)"
                        (patientByStatusFilter)="onChangePatientByStatusFilter($event.status, $event.value)"
                        (fromDateToQps)="onChangeFromDateFilter($event)">
                    </app-filter-by-agreements>
                </div>

                <div>
                    @if(!!specialtySelected){
                    <app-markers-list
                        (locateMarker)="onPressMarkerLocation($event)"
                        [actualCenter]="this.actualCenter"
                        [locationsFiltered]="this.providersLocationsFilteredPois"
                        [typeMarkers]="'PROVIDERS'"
                        [reset]="resetList"
                        [providerAddressVisibility]="providerMarkerSelectedAddressVisibility"
                        [providerZonesVisibility]="providerMarkerSelectedZonesVisibility"
                    >
                    </app-markers-list>
                    }
                </div>
            </form>
        </mat-tab>
       @if(providerMarkerSelected){
        <mat-tab>
            <ng-template mat-tab-label>
                <div class="flex-row align-center-center gap-1em" style="width: 3em;">
                    <div class="flex-70 align-center-center prs-2 ">
                        <mat-icon [style.height.px]="24" [style.width.px]="24" svgIcon="provider-home-black" ></mat-icon>
                    </div>
                    <div class="tab-close-icon"(click)="closeProviderMarkerTab()">
                        <mat-icon
                          [style.height.px]="20"
                          [style.width.px]="20"
                          svgIcon="close">
                        </mat-icon>
                      </div>
                </div>
            </ng-template>
            <div class="flex-100" style="width:420px;">
                @if(!!providerMarkerSelected){
                    <div class="flex-column p-2 gap-1em">
                    <!-- STATE & NAME-->
                    <div class="flex-row align-center-center pys-3 gap-0-5em line-separator ">
                        <span class="state-chip provider-tag subtitle-4" [ngStyle]="{color: PROVIDERS_STATUS_COLORS['ACTIVE'],
                                     'background-color': PROVIDERS_STATUS_BACKGROUND_COLORS['ACTIVE']}">
                            A
                        </span>
                        <span class="flex-90 mxs-1 subtitle-4"
                            style="line-height: inherit;">{{providerMarkerSelected.name}}
                        </span>
                        <div class="flex-row">
                            <mat-icon class="cursor-pointer mls-3" [style.width.px]="24" (click)="showProviderCard()"
                            [style.height.px]="24" [style.color]="MAP_MARKER_COLORS[providerMarkerSelected.type]"
                            [svgIcon]="IconMapMarkers[providerMarkerSelected.type]">
                        </mat-icon>
                        </div>
                        <mat-icon class="flex-1-1-auto" [color]="'primary'" style="line-height: 0.8"
                            (click)="setDataVisible()">
                            {{ dataVisible ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
                        </mat-icon>
                    </div>
                    @if(dataVisible){
                    <div class="flex-column gap-1em line-separator pbs-3">
                        <div class="flex-row gap-2em">
                            <!-- DNI -->
                            <div class="flex-row gap-1em">
                                <span class="subtitle-3 text-primary  mbs-1"> DNI</span>
                                <span class="subtitle-4 text-primary-darker  mbs-1">
                                    {{providerMarkerSelected.dni ?? '-'}}</span>
                            </div>
                            <!-- Phone number -->
                            <div class="flex-row gap-1em">
                                <span class="subtitle-3 text-primary  mbs-1"> {{ 'modules.providers.specialties-providers-pois.numero-de-telefono' | exp:'':'Número de teléfono' }}</span>
                                <span class="subtitle-4 text-primary-darker  mbs-1">
                                    {{providerMarkerSelected.phone ?? ('modules.providers.specialties-providers-pois.sin-telefono' | exp:'':'Sin teléfono')}}</span>
                            </div>
                        </div>
                        <!-- Email -->
                        <div class="flex-row gap-1em">
                            <span class="subtitle-3 text-primary  mbs-1"> {{ 'modules.providers.specialties-providers-pois.email' | exp:'':'Email' }}</span>
                            <span class="subtitle-4 text-primary-darker  mbs-1">{{providerMarkerSelected.email ?? ('modules.providers.specialties-providers-pois.sin-email' | exp:'':'Sin email')}}
                            </span>
                        </div>
                        <!-- Adress -->
                        <div class="flex-row gap-1em">
                            <span class="subtitle-3 text-primary  mbs-1"> {{ 'modules.providers.specialties-providers-pois.domicilio' | exp:'':'Domicilio' }}</span>
                            <span class="subtitle-4 text-primary-darker  mbs-1">
                                {{providerMarkerSelected.address ?? '-'}}</span>
                        </div>
                    </div>
                    <div class="flex-column gap-1em line-separator pbs-3">
                        <!-- -->
                        <!-- Specialty -->
                        <div class="flex-row gap-1em">
                            <span class="subtitle-3 text-primary  mbs-1"> {{ 'modules.providers.specialties-providers-pois.especialidad' | exp:'':'Especialidad' }}</span>
                            <span
                                class="subtitle-4 text-primary-darker  mbs-1">{{providerMarkerSelected.specialties[0].name ?? '-'}}</span>
                        </div>
                        <!-- License -->
                        <div *ngFor="let medicalLicense of providerMarkerSelected.specialties[0].medicalLicenses">
                            <div class="flex-row gap-0-25em pls-1">
                                <span class="subtitle-2 text-primary-darker align-center-center  mbs-1"> ·</span>
                                <span class="subtitle-3 text-primary-darker  mbs-1">{{medicalLicense.type.name ?? '-'}}</span>
                                <span class="subtitle-3 text-primary mbs-1"> {{medicalLicense.value ?? '-'}}</span>
                                @if(medicalLicense?.value){
                                    <mat-icon class="cursor-pointer pls-2" (click)="copyToClipboard(medicalLicense?.value)"[style.width.px]="14" [style.height.px]="14" svgIcon="copy" [matTooltip]="('modules.providers.specialties-providers-pois.tooltips.copiar' | exp:'':'Copiar')"></mat-icon>
                                }
                            </div>
                        <!-- Verify License -->
                        @if(medicalLicense?.value){
                        <div class="flex align-end-center"(click)="onGetSisa(medicalLicense.value)">
                            <span class="subtitle-6 text-primary-darker" style="cursor: pointer;letter-spacing: 0.0625rem"><u>{{ 'modules.providers.specialties-providers-pois.verificar-matricula-sisa' | exp:'':'Verificar Matrícula (Sisa)' }}</u></span>
                        </div>
                        }
                        </div>
                    </div>
                    <!-- -->
                    <!-- ACTION BTNS -->
                    <div class="flex-column">
                        <app-checkbox-input [form]="providersForm" [label]="('modules.providers.specialties-providers-pois.incluir-domicilio-del-prestador' | exp:'':'Incluir domicilio del prestador')"
                            name="includeProviderPatientsAddress" [disabled]="!enableFilters">
                        </app-checkbox-input>

                        <app-checkbox-input [form]="providersForm" [label]="('modules.providers.specialties-providers-pois.incluir-zonas-de-trabajo-del-prestador' | exp:'':'Incluir zonas de trabajo del prestador')"
                            name="includeProviderPatientsZone" [disabled]="!enableFilters">
                        </app-checkbox-input>

                        <div class="flex-row gap-1em flex-100 align-center-center pts-2">
                            <div class="action-btn" role="button" tabindex="0" (click)="goToProviderSchedule(providerMarkerSelected)">
                                <mat-icon svgIcon="calendar-primary" class="actions-btns-small"></mat-icon>
                                <span class="subtitle-3 text-primary-darker">{{ 'modules.providers.specialties-providers-pois.ver-agenda' | exp:'':'Ver Agenda' }}</span>
                            </div>

                            <div class="action-btn" role="button" tabindex="0" (click)="openReadOnly(providerMarkerSelected)">
                                <mat-icon svgIcon="user-docs-primary" class="actions-btns-small"></mat-icon>
                                <span class="subtitle-3 text-primary-darker">{{ 'modules.providers.specialties-providers-pois.documentacion' | exp:'':'Documentación' }}</span>
                            </div>
                        </div>
                    </div>
                    }

                    <app-markers-list
                        [patientsList]="providerPatients"
                        [actualCenter]="this.actualCenter"
                        [typeMarkers]="'PATIENTS'"
                        (locateMarker)="onPressMarkerLocation($event)"
                        [listFocused]="onGetPatientsFocus"
                    >
                    </app-markers-list>
                </div>
                }
            </div>
        </mat-tab>
        }

    </mat-tab-group>


    <div class="flex" #mapDiv>
        @if(this.mapsService.isApiLoaded()){
        <app-map class="flex" style="width: 100vh;" [width]="mapWidth" [height]="mapHeight"
            [specialtyId]="specialtySelected" [specialtyName]="specialtyName" [showProviders]="!showAllProvidersList"
            [markerSelected]="this.markerSelectedFromProviderList" (providerShowInfo)="onProviderMarkerSelected($event)"
            (actualCenter)="getMapCenter($event)">
        </app-map>
        <!-- Float bar with map references -->
        <div class="map-refs mxs-4 align-center-center map-refs-pxs"[style.width.px]="mapRefsWidth">
            <div class="space-between-center" [ngClass]="sideNavExpanded ? 'row-wrap' : 'flex-row'">

                <div class="flex-row flex-60 align-center-center">
                    <div class="flex-row align-center-center gap-0-5em flex-25 map-refs-chip">
                        <mat-icon [style.width.px]="26" [style.height.px]="26" svgIcon="patient-home-primary"></mat-icon>
                        <span class="subtitle-6">{{ 'modules.providers.specialties-providers-pois.domicilio-paciente' | exp:'':'Domicilio Paciente' }}</span>
                    </div>

                    <div class="flex-row align-center-center map-refs-chip gap-0-5em flex-25">
                        <mat-icon [style.width.px]="26" [style.height.px]="26" svgIcon="provider-home-primary"></mat-icon>
                        <span class="subtitle-6">{{ 'modules.providers.specialties-providers-pois.domicilio-prestador' | exp:'':'Domicilio Prestador' }}</span>
                    </div>

                    <div class="flex-row align-center-center map-refs-chip gap-0-5em flex-25">
                        <mat-icon [style.width.px]="26" [style.height.px]="26" svgIcon="provider-zone-primary"></mat-icon>
                        <span class="subtitle-6">{{ 'modules.providers.specialties-providers-pois.zona-de-trabajo-prestador' | exp:'':'Zona De Trabajo Prestador' }}</span>
                    </div>

                     <div class="flex-row align-center-center map-refs-chip gap-0-5em flex-25">
                        <mat-icon [style.width.px]="26" [style.height.px]="26" svgIcon="cluster-ref-primary"></mat-icon>
                        <span class="subtitle-6">{{ 'modules.providers.specialties-providers-pois.prestadores-agrupados' | exp:'':'Prestadores Agrupados' }}</span>
                    </div>

                </div>
                <div class="flex-row flex-40 align-center-center">
                    <div class="flex-row align-center-center map-refs-chip gap-0-5em p-1 flex-25"  [matTooltip]="('modules.providers.specialties-providers-pois.tooltips.activo' | exp:'':'Activo') ">
                        <mat-icon [style.width.px]="14" [style.height.px]="14" svgIcon="dot-green"></mat-icon>
                        <span class="subtitle-6">A</span>
                    </div>

                    <div class="flex-row align-center-center map-refs-chip gap-0-5em p-1 flex-25 " [matTooltip]="('modules.providers.specialties-providers-pois.tooltips.posible' | exp:'':'Posible') ">
                        <mat-icon [style.width.px]="14" [style.height.px]="14" svgIcon="dot-yellow"></mat-icon>
                        <span class="subtitle-6" >P</span>
                    </div>

                     <div class="flex-row align-center-center map-refs-chip gap-0-5em p-1 flex-25"  [matTooltip]="('modules.providers.specialties-providers-pois.tooltips.cancelado' | exp:'':'Cancelado') " >
                        <mat-icon [style.width.px]="14" [style.height.px]="14" svgIcon="dot-red"></mat-icon>
                        <span class="subtitle-6">C</span>
                    </div>

                     <div class="flex-row align-center-center map-refs-chip gap-0-5em p-1 flex-25 "  [matTooltip]="('modules.providers.specialties-providers-pois.tooltips.inactivo' | exp:'':'Inactivo') ">
                        <mat-icon [style.width.px]="14" [style.height.px]="14" svgIcon="dot-grey"></mat-icon>
                        <span class="subtitle-6">I</span>
                    </div>
                </div>




            </div>
        </div>
        }
    </div>
</app-theme-card>


<ng-template #providerDSPHost>
    <ng-container *ngComponentOutlet="providersManagementCmp; injector: dspInjector">
    </ng-container>
</ng-template>
